export enum EventType {
  PAGE_VISIT = 'PAGE_VISIT',
  FIELD_VISIT = 'FIELD_VISIT',
  SUPPORT_REQUEST = 'SUPPORT_REQUEST',
  PAGE_ACTION = 'PAGE_ACTION'
}

export enum ActionType {
  CLICK = 'CLICK',
  SKIP = 'SKIP',
  VIEW = 'VIEW',
  CHANGE = 'CHANGE'
}

export enum PageName {
  ONBOARDING_BUSINESS_INFO = 'BUSINESS_INFO',
  ONBOARDING_BILLING_ADDRESS = 'BILLING_ADDRESS',
  ONBOARDING_BUSINESS_TOOLS = 'BUSINESS_TOOLS',
  ONBOARDING_PASSWORD = 'BUSINESS_PASSWORD',
  ONBOARDING_EMAIL_VERIFICATION = 'EMAIL_VERIFICATION',
  ONBOARDING_PHONE_VERIFICATION = 'PHONE_VERIFICATION',
  ONBOARDING_KICK_OFF_MEETING = 'KICK_OFF_MEETING',
  ONBOARDING_SUB_ACCOUNT_CREATE = 'SUB_ACCOUNT_CREATE',
  AGENCY_DASHBOARD = 'AGENCY_DASHBOARD'
}

export enum SourceType {
  AFFILIATE = 'AFFILIATE',
  FUNNEL = 'FUNNEL'
}

export interface TrackEventBody {
  companyId: string
  userId: string
  eventType: EventType
  actionType: ActionType
  version: number
  elementName: string
  pageUri?: string
  value?: string
  variationId?: string
  pageName: PageName
  source: SourceType
  country?: string
  plan: string
  device?: string
  browser?: string
}
